import SettingTypes from "@/utils/setting-types"

export default {
  name: 'popup',
  label: {
    title: '弹窗公告',
    icon: require('@/assets/icon-component-label_Notice.png'),
    limit: 1
  },
  decor_type: 'admin',
  sort: 13,
  data: {
    // 弹窗状态 打开 open  关闭close
    popup_status: 'close',
    // 弹窗类型 文字 text 图片 image
    popup_type: 'text',
    // 显示标题
    show_title: true,
    // 弹窗时间
    content_time: '',
    // 弹窗文本类型 文字 text 富文本 rich-text
    content_type: 'text',
    // 标题内容
    title: '提示',
    // 标题字体大小
    title_font_size: 32,
    // 标题字体粗细
    title_font_weight: '400',
    // 弹窗内容
    popup_content: '默认公告！',
    // 富文本内容
    content: '',
    // 内容字体大小
    content_font_size: 32,
    // 内容字体粗细
    content_font_weight: '400',
    // 弹窗图片
    popup_image: '',
    // 字体颜色
    popup_color: '#000000',
    // 背景颜色
    background_color: '#ffffff',
    // 圆角
    background_radius: 20,
    // 页面边距
    page_edge: 20,
    // 关闭图标
    closeable: true,
    // 点击遮罩是否可以关闭弹出层
    is_mask_close: true,
    // 关闭返回
    is_back: false,
    // 宽
    width: 400,
    // 高
    height: 400
  },
  settings: {
    content_time: {
      type: SettingTypes.date_picker,
      label: '弹窗时间'
    },
    popup_status: {
      type: SettingTypes.radio_button,
      label: '弹窗状态（预览，保存时需关闭）',
      options: [
        { label: '打开', value: 'open' },
        { label: '关闭', value: 'close' }
      ]
    },
    popup_type: {
      type: SettingTypes.radio_button,
      label: '弹窗类型',
      options: [
        { label: '文字', value: 'text' },
        { label: '图片', value: 'image' }
      ]
    },
    content_type: {
      type: SettingTypes.radio_button,
      label: '文本类型',
      options: [
        { label: '文字', value: 'text' },
        { label: '富文本', value: 'rich-text' }
      ],
      show: (data) => data.popup_type === 'text'
    },
    show_title: {
      type: SettingTypes.radio_button,
      label: '标题',
      options: [
        { label: '显示', value: true },
        { label: '隐藏', value: false }
      ],
      show: (data) => data.popup_type === 'text' && data.content_type === 'text'
    },
    title: {
      type: SettingTypes.input,
      label: '标题内容',
      show: (data) => data.show_title && data.popup_type === 'text' && data.content_type === 'text',
    },
    popup_content: {
      type: SettingTypes.input,
      label: '弹窗内容',
      props: {
        type: 'textarea',
        placeholder: '请输入弹窗内容，最多300个字！',
        maxlength: 300
      },
      show: (data) => data.popup_type === 'text' && data.content_type === 'text',
      space_line: true
    },
    content: {
      type: SettingTypes.custom,
      component_name: 'RichTextEditor',
      show: (data) => data.popup_type === 'text'  && data.content_type === 'rich-text',
      space_line: true
    },
    popup_image: {
      type: SettingTypes.custom,
      component_name: 'customImage',
      show: (data) => data.popup_type === 'image',
      space_line: true
    },
    popup_color: {
      type: SettingTypes.color_picker,
      label: '字体颜色',
      default: '#000000',
      show: (data) => data.popup_type === 'text' && data.content_type === 'text',
    },
    title_font_size: {
      type: SettingTypes.radio_button,
      label: '标题大小',
      options: [
        { label: '大（16号）', value: 32, icon: 'rb-icon-font-x' },
        { label: '中（14号）', value: 28, icon: 'rb-icon-font-m' },
        { label: '小（12号）', value: 24, icon: 'rb-icon-font-s' }
      ],
      show: (data) => data.popup_type === 'text' && data.content_type === 'text'
    },
    title_font_weight: {
      type: SettingTypes.radio_button,
      label: '标题粗细',
      options: [
        { label: '常规体', value: '400', icon: 'rb-icon-font-regular' },
        { label: '加粗体', value: 'bold', icon: 'rb-icon-font-bold' }
      ],
      show: (data) => data.popup_type === 'text' && data.content_type === 'text'
    },
    content_font_size: {
      type: SettingTypes.radio_button,
      label: '内容大小',
      options: [
        { label: '大（16号）', value: 32, icon: 'rb-icon-font-x' },
        { label: '中（14号）', value: 28, icon: 'rb-icon-font-m' },
        { label: '小（12号）', value: 24, icon: 'rb-icon-font-s' }
      ],
      show: (data) => data.popup_type === 'text' && data.content_type === 'text'
    },
    content_font_weight: {
      type: SettingTypes.radio_button,
      label: '内容粗细',
      options: [
        { label: '常规体', value: '400', icon: 'rb-icon-font-regular' },
        { label: '加粗体', value: 'bold', icon: 'rb-icon-font-bold' }
      ],
      show: (data) => data.popup_type === 'text' && data.content_type === 'text',
      space_line: true
    },
    background_color: {
      type: SettingTypes.color_picker,
      label: '背景颜色',
      default: '#ffffff'
    },
    background_radius: {
      type: SettingTypes.slider,
      label: '背景圆角',
      props: {
        min: 0,
        max: 60
      }
    },
    page_edge: {
      type: SettingTypes.slider,
      label: '页面边距',
      props: {
        min: 0,
        max: 60
      }
    },
    width: {
      type: SettingTypes.slider,
      label: '宽',
      props: {
        min: 100,
        max: 600
      }
    },
    height: {
      type: SettingTypes.slider,
      label: '高',
      props: {
        min: 100,
        max: 1000
      },
      space_line: true
    },
    closeable: {
      type: SettingTypes.boolean,
      label: '关闭按钮',
      props: {
        activeText: '是',
        inactiveText: '否'
      },
      show: (data) => data.popup_type === 'text'
    },
    is_mask_close: {
      type: SettingTypes.boolean,
      label: '点击遮罩是否可以关闭弹窗',
      props: {
        activeText: '是',
        inactiveText: '否'
      }
    },
    is_back: {
      type: SettingTypes.boolean,
      label: '关闭后是否需要返回首页',
      props: {
        activeText: '是',
        inactiveText: '否'
      }
    }
  }
}